import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class SelectListService {

  constructor(private http: HttpClient) { }

  getSelectListData(baseUrl: string, data: Array<{ name: string, value: any }>): Observable<any> {
    let url = '';
    if (data && data.length > 0) {
      url = baseUrl + '?';
      data.forEach(element => {
        if(typeof(element.value) == 'object') {
          element.value.forEach(value => {
            url += element.name + '=' + value + '&';
          });
        } else {
          url += element.name + '=' + element.value + '&';
        }
      });
      url = url.slice(0, -1);
    } else {
      url = baseUrl;
    }

    return this.http.get(url)
    .pipe(
      map(result => {
        return result;
      }),
      catchError(error => {
        return throwError(new Error(error));
      })
    );
  }

}
